import React from 'react';
import { Weight, Activity } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PetProfile } from '../../types';

interface PetStatsCardsProps {
  profile: PetProfile;
  history: any[];
}

export const PetStatsCards: React.FC<PetStatsCardsProps> = ({ profile, history }) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="bg-white p-5 rounded-[2rem] border border-gray-100 shadow-sm">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${profile.type === 'chat' ? 'bg-orange-50 text-orange-500' : 'bg-indigo-50 text-indigo-600'}`}>
          <Weight size={20} />
        </div>
        <p className="text-[10px] font-black uppercase text-gray-400 mb-1">{t('app:dashboard.current_weight')}</p>
        <div className="flex items-baseline gap-1">
          <p className="text-3xl font-black text-gray-900">{profile.weight || '0'}</p>
          <p className="text-sm font-bold text-gray-400">kg</p>
        </div>
      </div>
      <div className="bg-white p-5 rounded-[2rem] border border-gray-100 shadow-sm">
        <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center text-emerald-600 mb-4">
          <Activity size={20} />
        </div>
        <p className="text-[10px] font-black uppercase text-gray-400 mb-1">{t('app:dashboard.last_status')}</p>
        <p className="text-xl font-black truncate capitalize text-gray-900">{history.find(h=>h.mood)?.mood || '...'}</p>
      </div>
    </div>
  );
};
